module.exports = __webpack_public_path__ + "static/media/mf.85556bea.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/mf.svg
// module id = 186
// module chunks = 0